import React, { useState } from 'react';

import { TabStrip, TabStripTab } from '@progress/kendo-react-layout';
import EquipmentEnergyPanel from './EquipmentEnergyPanel';

const EquipmentTabContainer = ({
    availableSensors,
    energyValue,
    equipmentAttributes,
    formik,
    hasValidated,
    sensorAttributes,
    sensors,
    setEnergyValue,
    setSensors,
    ...props
}) => {
    const [selected, setSelected] = useState(0);
    const handleSelect = (e) => {
        setSelected(e.selected);
    };

    return (
        <React.Fragment>
            <style>
                {
                    `.k-tabstrip-items-wrapper .k-item.k-active::after {
                        border-color: black;
                        font-weight: 500;
                    }
                    .k-tabstrip-items {
                        text-transform: none;
                        font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif;
                        font-weight: 400;
                    }
                    .k-animation-container-relative {
                        min-width: 180px;
                        width: 100%;
                    }
                    `
                }
            </style>
            <TabStrip selected={selected} onSelect={handleSelect}>
                <TabStripTab title="Energy">
                    <EquipmentEnergyPanel
                        availableSensors={availableSensors}
                        energyValue={energyValue}
                        equipmentAttributes={equipmentAttributes}
                        formik={formik}
                        hasValidated={hasValidated}
                        sensorAttributes={sensorAttributes}
                        sensors={sensors}
                        setEnergyValue={setEnergyValue}
                        setSensors={setSensors}
                    />
                </TabStripTab>
            </TabStrip>
        </React.Fragment>
    );
};

export default EquipmentTabContainer;
